import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildIncidentDetailPath } from '~/app/components/asset-detail/assetIncidentRoutes';
import { isCurativeTicketType } from '@evimo/components/maintenance/work-orders/WorkOrderKanbanPageContainer/utils';

/**
 * Corrective maintenance tickets must land on the incident detail page, not
 * the maintenance ticket detail route.
 */
export function useCurativeTicketIncidentRedirect(args: {
  ticketType: string | undefined;
  incidentId: string | null;
  isLoading: boolean;
}) {
  const navigate = useNavigate();
  const { ticketType, incidentId, isLoading } = args;

  useEffect(() => {
    if (isLoading || !ticketType) {
      return;
    }
    const linkedIncidentId = incidentId?.trim() ?? '';
    if (!isCurativeTicketType(ticketType) || !linkedIncidentId) {
      return;
    }
    navigate(buildIncidentDetailPath(linkedIncidentId), { replace: true });
  }, [incidentId, isLoading, navigate, ticketType]);
}
